import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { app, facebookProvider, database } from '../config/base'
import imgHeader from '../assets/img/signupheader.png'

import pdf from './reglement.pdf'
import btnconf from '../assets/img/btnconf.png'
class SignUp extends Component {

  constructor() {
    super();
    this.state = {
        username:"",
        imgUrl:"",
        name:'',
        surname:'',
        email:'',
        tel:'',
        wileya:'',
        btnDisabled:true
    };

  }

  componentWillMount()
  {
    var _this= this
    app.auth().onAuthStateChanged(function(user) {
  if (user) {
    console.log(user.photoURL)
    _this.setState({
      username:user.displayName,
      imgUrl:user.photoURL,
        btnDisabled:true
    })
  } else {
    console.log("error")
  }
});
  }

  handleName(event)
  {
    console.log("cdsc")
    this.setState({
      name:event.target.value
    })
  }

  handleSurename(event)
  {
    this.setState({
      surname:event.target.value
    })
  }

  handleEmail(event)
  {
    this.setState({
      email:event.target.value
    })
  }
  handleTel(event)
  {
    this.setState({
      tel:event.target.value
    })
  }

  handleWileya(event)
  {
    this.setState({
      wileya:event.target.value
    })
    if (this.state.name!="" && this.state.surname!="")
    this.setState({
      btnDisabled:false
    })
  }
  handleSubmit()
  {
    console.log(this.state);
      var _this = this
    app.auth().onAuthStateChanged(function(user) {
  if (user) {
    var url='users/'+user.uid
    console.log(user.providerData[0].uid)
    database.ref(url).set({
        fbid:user.providerData[0].uid,
        name: _this.state.username,
        email: _this.state.email,
        surname:_this.state.surname,
        wileya:_this.state.wileya,
        tel:_this.state.tel
      });
      _this.setState({
        redirect:true
      })
  }
})

  }


  render() {
    if (this.state.redirect === true) {
      return <Redirect  to='/' />
    }
      var classBtn="btnConf errorBtn"
    if (this.state.btnDisabled==true)
     classBtn="btnConf"
    else
    classBtn="btnConf errorBtn"
    return (
      <div>

        <img src={imgHeader} className="questionsheader" alt='header'/>
        <div className="userinfos">

          <img src={this.state.imgUrl} alt={this.state.username}/>
          <h3>Bonjour, {this.state.username}</h3>
          <h4>Merci de remplir le formulaire suivant:</h4>
        </div>
        <div className="inputContainer">

          <div className="inputAligned">

            <input type="text" className="input" placeholder="Nom" onChange={this.handleName.bind(this)} required/>
            <input type="text" className="input" placeholder="Prénom" onChange={this.handleSurename.bind(this)}  required/>

          </div>
          <div className="inputAligned">
            <input type="email" className="input" placeholder="Adresse Email" onChange={this.handleEmail.bind(this)}  required/>
          </div>
          <div className="inputAligned">
            <div className="inputAlignedText">
              <input type="number" className="input" placeholder="N° de téléphone" onChange={this.handleTel.bind(this)}  required/>

              <select className="input selectbox" onChange={this.handleWileya.bind(this)} >
                <option>
                  Wilaya
                </option>
                <option>Algérie</option>
                <option>
                  Adrar
                </option>
                <option>Chlef</option><option>Laghouat</option><option>Oum el-Bouaghi</option><option>Batna</option><option>Béjaïa</option><option>Biskra</option><option>Béchar</option>
                <option>Blida</option><option>Bouïra</option><option>Tamanghasset</option><option>Tébessa</option><option>Tlemcen</option><option>Tiaret</option>
                <option>Tizi Ouzou</option><option>Algiers</option><option>Djelfa</option><option>	Jijel</option><option>Sétif</option><option>Saïda</option><option>Skikda</option>
                <option>Sidi Bel Abbès</option><option>Annaba</option><option>Guelma</option><option>Constantine</option><option>Médéa</option><option>Mostaganem</option><option>M'Sila</option>
                <option>Mascara</option><option>Ouargla</option><option>Oran</option><option>El Bayadh</option><option>Illizi</option><option>Bordj Bou Arréridj</option>
                <option>Boumerdès</option><option>El Taref</option><option>Tindouf</option><option>Tissemsilt</option><option>El Oued</option><option>Khenchela</option>
                <option>Souk Ahras</option><option>Tipasa</option><option>Mila</option><option>Aïn Defla</option><option>Naâma</option><option>Aïn Témouchent</option><option>Ghardaïa</option>
                <option>Relizane</option>

              </select>

            </div>


          </div>
          <div className="inputAligned">
            <p className="textleft">Tout les champs sont obligatoires !</p>


          </div>





          <div className="inputAligned">

            <label><input type="radio" className="btnRadio"/>
              <span>J’ai lu et accepté </span><strong> <a className="strong" target="_blank" href={pdf} required> le règlement du concours</a></strong>
            </label>

          </div>

          <button disabled={this.state.btnDisabled}  className={classBtn} onClick={this.handleSubmit.bind(this)}>  <img src={btnconf}/></button>
        </div>


      </div>
        );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp.js